export function renderTeamBlock({ data, content, assignments, report }) {
  if (!assignments) return;

  const systemLabels = {
    koordinaattori: "Koordinaattori",
    kuntotutkija: "Kuntotutkija",
    rakennustekniikka: "Rakennustekniikka",
    lvia: "LVIA-järjestelmät",
    sahko: "Sähköjärjestelmät",
  };


  const getMode = (systemKey, userId) => {
    return (
      data?.modes?.[systemKey]?.[userId] ??
      (report?.type === "wk3" ? "ammattinimike" : "yritys")
    );
  };

  Object.keys(systemLabels).forEach((systemKey) => {
    const assignedUsers = assignments[systemKey] || [];

    if (assignedUsers.length === 0) return;

    // Combine names
    const names = assignedUsers
      .map((u) => u.nimi || u.sahkoposti || "—")
      .join("\n");

   
    const selite = assignedUsers
      .map((u) => {
        const mode = getMode(systemKey, u.id);

        return mode === "yritys"
          ? u.yritys || "—"
          : u.ammattinimike || "—";
      })
      .join("\n");

    content.push({
      table: {
        widths: ["30%", "35%", "35%"],
        body: [
          [
            {
              text: systemLabels[systemKey],
              style: "paragraph",
              margin: [0, 0, 0, 0],
            },
            {
              text: names,
              style: "paragraph",
              margin: [0, 0, 0, 0],
            },
            {
              text: selite,
              style: "paragraph",
              margin: [0, 0, 0, 0],
            },
          ],
        ],
      },
      layout: "noBorders",
      style: "paragraph",
    });
  });
}